import React, { useState } from "react";
//#region ________ Images ________
import Logo from "../../assets/img/logo-branca.svg";
import Menu from "../../assets/img/menu.svg";
import Lupa from "../../assets/img/lupa.svg";
import User from "../../assets/img/user.svg";
import Close from "../../assets/img/close.svg";
import IcoPredio from "../../assets/img/ico-predio.svg";
import IcoDolar from "../../assets/img/ico-dolar.svg";
import IcoA from "../../assets/img/ico-a.svg";
import IcoB from "../../assets/img/ico-b.svg";
import IcoT from "../../assets/img/ico-t.svg";
import IcoInvestiment from "../../assets/img/ico-investimento.svg";
import IcoForm from "../../assets/img/ico-form.svg";
import IcoEscudo from "../../assets/img/ico-escudo.svg";
import IcoMao from "../../assets/img/ico-mao.svg";
import IcoPasta from "../../assets/img/ico-pasta.png";
import IcoFone from "../../assets/img/ico-fone.svg";
import IcoLivro from "../../assets/img/ico-livro.svg";
import logoMobile from "../../assets/img/logo-forluz-texte.svg";
import icoPerson from "../../assets/img/ico-person.svg";
import IcoViver from "../../assets/img/ico-viver.svg";
import "./styles.css";
import { hotjar } from 'react-hotjar';


const Header = () => {
  const [showMenu, SetShowMenu] = useState<string>("");
  const [participantArea, SetParticipantArea] = useState<string>('-656px');

  /*
    hjid: Stands for 'Hotjar ID' - Your site's ID. This is the ID which tells Hotjar which site settings it should load and where it should save the data collected.

    hjsv: Stands for 'Hotjar Snippet Version' - The version of the Tracking Code you are using. This is only needed if Hotjar ever updates the Tracking Code and needs to discontinue older ones. Knowing which version your site includes allows hotjar team to contact you and inform you accordingly.
  */
  const hjid = 3323441;
  const hjsv = 6;
  hotjar.initialize(hjid, hjsv);

  return (
    <>
      <header className="header position-relative position-fixed w-100">
        <div className="desktop-menu d-none d-lg-block">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <div className="header__logo">
                    <h1>
                      <a href="/home">
                        <img src={Logo} alt="Logo" />
                      </a>
                    </h1>
                  </div>

                  <div
                    onClick={() => { SetShowMenu("active"); $("body").css({ overflow: 'hidden' }) }}
                    className="header__menu ml-9"
                  >
                    <a
                      href="#"
                      className="btn btn-outline-white btn-icon btn-menu rounded transition py-2 px-5"
                    >
                      <img
                        src={Menu}
                        alt="Abrir menu"
                        width="18"
                        height="12"
                        className="mr-3"
                      />{" "}
                      Menu{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="d-flex justify-content-end align-items-center">
                  <div className="header__busca rounded">
                    <form action="/resultado-busca">
                      <button type="submit" className="btn-busca">
                        {" "}
                        <img
                          src={Lupa}
                          alt="Abrir menu"
                          width="16"
                          height="16"
                          className="mr-1 ml-1"
                        />{" "}
                      </button>
                      <input
                        type="text"
                        name="s"
                        id="s"
                        placeholder="O que você procura?"
                        required
                      />
                    </form>
                  </div>

                  <a
                    href="https://participante.forluz.org.br/"

                    className="btn btn-outline-white btn-icon rounded transition py-2 px-4 ml-6 open-login"
                  >
                    <img
                      src={User}
                      alt="Abrir menu"
                      width="15"
                      height="16"
                      className="mr-3"
                    />{" "}
                    <span> Área do participante </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="_mobile-menu py-1 px-3 d-lg-none">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-10">
                <div className="logo-branca">
                  <a href="/home">
                    <img src={logoMobile} alt="Logo" />
                  </a>
                </div>
              </div>
              <div className="col-2">
                <input type="checkbox" className="d-lg-none" id="open-menu" />

                <label
                  htmlFor="open-menu"
                  className="menu-icon mb-0 mt-2 d-inline-block d-lg-none"
                >
                  <span className="menu-bar d-block"></span>
                  <span className="menu-bar d-block"></span>
                  <span className="menu-bar d-block"></span>
                </label>

                <div className="menu-overlay d-lg-none"></div>

                <div className="_nav-menu">
                  <div className="_nav-menu-topo">
                    <div className="logo">
                      <a href="./">
                        <img src={logoMobile} alt="Logo" />
                      </a>
                    </div>

                    <a
                      href="https://participante.forluz.org.br/"

                      className="btn btn-outline-white btn-icon btn-menu rounded transition py-2 px-4 w-100 text-left btn-100 open-login"
                    >
                      <img
                        src={User}
                        alt="Abrir menu"
                        width="15"
                        height="16"
                        className="mr-3"
                      />
                      <span> Área do participante </span>
                    </a>

                    <div className="header__busca rounded mt-4">
                      <form action="/resultado-busca">
                        <button type="submit" className="btn-busca">
                          {" "}
                          <img
                            src={Lupa}
                            alt="Abrir menu"
                            width="16"
                            height="16"
                            className="mr-1 ml-1"
                          />{" "}
                        </button>
                        <input
                          type="text"
                          name="s-mobile"
                          id="s-mobile"
                          placeholder="O que você procura?"
                          required
                        />
                      </form>
                    </div>
                  </div>

                  <div className="_nav-menu-list py-6">
                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={IcoPredio}
                            alt="prédio"
                            width="22"
                            height="20"
                          />
                          <span> A Forluz </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/historia"> História </a>
                        </li>
                        <li>
                          <a href="/missao">
                            {" "}
                            Missão, Visão e Valores{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/organograma"> Organograma </a>
                        </li>
                        <li>
                          <a href="/estatuto"> Estatuto </a>
                        </li>
                        <li>
                          <a href="/numeros"> Forluz em Números </a>
                        </li>
                        <li>
                          <a href="/conselhos"> Conselhos </a>
                        </li>
                        <li>
                          {/* <a href="https://www.forluz.org.br/AForluz/SitePages/Comit%C3%AA%20de%20Auditoria.aspx" target="_blank"> Comitê </a> */}
                          <a href="/comite"> Comitê </a>
                        </li>
                        <li>
                          <a href="/diretoria-executiva">
                            {" "}
                            Diretoria Executiva{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={IcoDolar}
                            alt="prédio"
                            width="18"
                            height="20"
                          />
                          <span> Acontece na Forluz </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/acontece-na-forluz/noticias"> Notícias </a>
                        </li>
                        <li>
                          <a href="/acontece-na-forluz/comunicados"> Comunicados </a>
                        </li>
                        <li>
                          <a href="/acontece-na-forluz/apresentacoes-especiais">
                            {" "}
                            Apresentações Especiais{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/acontece-na-forluz/publicacoes"> Publicações </a>
                        </li>
                        <li>
                          <a href="/acontece-na-forluz/guia-participante">
                            {" "}
                            Guia do Participante{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/acontece-na-forluz/relatorio-anual-informacoes">
                            {" "}
                            Relatório Anual de Informações{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                    {/* <div className="box-menu mb-6 mb-lg-0">
                      <div className="title">
                        <a rel="noreferrer"
                          href="https://www.forluz.org.br/ParaViverMelhor/Default.aspx"
                          target="_blank"
                          className="d-flex align-items-center"
                        >
                          <img src={IcoViver} alt="prédio" height="16" />
                          <span> Para Viver Melhor </span>
                        </a>
                      </div>
                    </div> */}
                    <div className="box-menu mb-6 mb-lg-0">
                      <div className="title">
                        <a rel="noreferrer" 
                          href="/ViverMelhor/para-viver-melhor"                        
                          className="d-flex align-items-center"
                        >
                          <img src={IcoViver} alt="prédio" height="16" />
                          <span> Para Viver Melhor </span>
                        </a>
                      </div>
                    </div>




                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img src={IcoA} alt="prédio" width="20" height="20" />
                          <span> Plano A </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/PlanoA/plano-a"> Descrição </a>
                        </li>
                        <li>
                          <a href="/PlanoA/plano-a-regulamento">
                            {" "}
                            Regulamento{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoA/plano-a-rentabilidades">
                            {" "}
                            Rentabilidade{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoA/Demonstracao-Atuarial">
                            {" "}
                            Demonstração Atuarial{" "}
                          </a>
                        </li>
                        <li>
                          <a rel="noreferrer" href="https://hotsiteplanoa.forluz.org.br" target="_blank">
                            {" "}
                            Hotsite do Plano A{" "}
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img src={IcoB} alt="prédio" width="20" height="20" />
                          <span> Plano B </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/PlanoB/plano-b-descricao">
                            {" "}
                            Descrição{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoB/plano-b-regulamento">
                            {" "}
                            Regulamento{" "}
                          </a>
                        </li>
                        <li>
                          <a href="./PlanoB/plano-b-cartilha">
                            {" "}
                            Cartilha do Participante{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoB/plano-b-rentabilidades">
                            {" "}
                            Rentabilidade{" "}
                          </a>
                        </li>
                        {/* <li>
                          <a href="/PlanoB/perfil-de-investimento">
                            {" "}
                            Perfil de Investimento{" "}
                          </a>
                        </li> */}
                        <li>
                          <a href="/PlanoB/Demonstracao-Atuarial">
                            {" "}
                            Demonstração Atuarial {" "}
                          </a>
                        </li>
                        {/* <li>
                          <a href="https://www.forluz.org.br/SitePages/calculadoraAporte.aspx" target="_blank">
                            {" "}
                            Calculadora de Aporte  {" "}
                          </a>
                        </li> */}
                      </ul>
                    </div>

                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img src={IcoT} alt="prédio" width="20" height="20" />
                          <span> Plano TaesaPrev </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/PlanoTaesaprev/plano-taesaprev-descricao">
                            {" "}
                            Descrição{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoTaesaprev/plano-taesaprev-regulamento">
                            {" "}
                            Regulamento{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoTaesaprev/plano-taesaprev-cartilha">
                            {" "}
                            Cartilha do Participante{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/PlanoTaesaprev/plano-taesaprev-rentabilidades">
                            {" "}
                            Rentabilidade{" "}
                          </a>
                        </li>
                        {/* <li>
                          <a href="/PlanoTaesaprev/perfil-de-investimento">
                            {" "}
                            Perfil de Investimento{" "}
                          </a>
                        </li> */}
                        <li>
                          <a href="/PlanoTaesaprev/Demonstracao-Atuarial">
                            {" "}
                            Demonstração Atuarial {" "}
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={IcoInvestiment}
                            alt="prédio"
                            width="22"
                            height="20"
                          />{" "}
                          <span> Investimentos </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/Investimentos/politica-investimentos">
                            {" "}
                            Política de Investimentos{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Investimentos/demonstracoes-financeiras">
                            {" "}
                            Demonstrações Financeiras{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Investimentos/demonstrativos-contabeis">
                            {" "}
                            Demonstrativos Contábeis{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Investimentos/demonstrativos-de-investimentos">
                            {" "}
                            Demonstrativos de Investimentos{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Investimentos/perfil-de-investimento">
                            {" "}
                            Perfil de Investimento{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Investimentos/calculadora-de-aporte">
                            {" "}
                            Calculadora de Aporte{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Investimentos/calculadora-de-contribuicao">
                            {" "}
                            Calculadora de Contribuição{" "}
                          </a>
                        </li>
                      </ul>
                    </div>


                    <div className="box-menu">
                      <div className="title">
                        <a
                          href="/emprestimos"
                          className="d-flex align-items-center"
                        >
                          <img
                            src={IcoMao}
                            alt="prédio"
                            width="23"
                            height="19"
                          />
                          <span> Empréstimos </span>
                        </a>
                      </div>
                    </div>
                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={IcoPasta}
                            alt="prédio"
                            width="21"
                            height="18"
                          />
                          <span> Transparência </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/Transparencia/extrato-tac"> Extrato TAC </a>
                        </li>
                        <li>
                          <a href="/Transparencia/acesso-informacao">
                            {" "}
                            Acesso à Informação{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Transparencia/relatorio-circunstanciado"> Relatório Circunstanciado </a>
                        </li>
                        <li>
                          <a href="/Transparencia/relatorio-proposito-especifico"> Relatório Propósito Específico </a>
                        </li>
                        {/* <li>
                          <a href="/Transparencia/relatorio-anual-informacoes"> Relatório Anual de Informações </a>
                        </li> */}
                      </ul>
                    </div>
                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={IcoLivro}
                            alt="prédio"
                            width="15"
                            height="20"
                          />
                          Governança
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/Governanca/politica-gov-corporativa">
                            {" "}
                            Política de Gov. Corporativa{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Governanca/codigo-etica-estatuto">
                            {" "}
                            Código de Conduta e Ética{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Governanca/canal-de-denuncia">
                            {" "}
                            Canal de Denúncia{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Governanca/lgpd"> LGPD </a>
                        </li>
                      </ul>
                    </div>
                    <div className="box-menu mb-6 mb-lg-0">
                      <div className="title">

                        <a
                          href="/gestaoderisco"
                          className="d-flex align-items-center"
                        >
                          <img
                            src={IcoEscudo}
                            alt="prédio"
                            width="23"
                            height="19"
                          />
                          <span> Gestão de Riscos </span>
                        </a>

                      </div>
                    </div>

                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={IcoFone}
                            alt="prédio"
                            width="20"
                            height="17"
                          />
                          <span> Contato </span>
                        </span>
                      </div>
                      <ul>
                        <li>
                          <a href="/Contato/fale-conosco"> Fale Conosco </a>
                        </li>
                        <li>
                          <a href="/Contato/perguntas-frequentes">
                            {" "}
                            Perguntas Frequentes{" "}
                          </a>
                        </li>
                        <li>
                          <a href="/Contato/canais-atendimento">
                            {" "}
                            Canais de Atendimento{" "}
                          </a>
                        </li>

                      </ul>
                    </div>
                    <div className="box-menu">
                      <div className="title">
                        <span className="d-flex align-items-center">
                          <img
                            src={icoPerson}
                            alt="prédio"
                            width="20"
                            height="17"
                          />
                          <span> Gestão de Pessoas </span>
                        </span>
                      </div>
                      <ul>
                        {/* <li>
                          <a href="/Contato/trabalhe-conosco">
                            {" "}
                            Trabalhe conosco{" "}
                          </a>
                        </li> */}
                        <li>
                          <a href="/Contato/nossas-praticas"> Nossas práticas </a>
                        </li>
                        <li>
                          <a href="/Contato/atracao-e-selecao"> Atração e seleção </a>
                        </li>

                      </ul>
                    </div>


                    <div className="box-menu mb-6 mb-lg-0">
                      <div className="title">
                        <a
                          href="/formularios"
                          className="d-flex align-items-center"
                        >
                          <img
                            src={IcoForm}
                            alt="prédio"
                            width="18"
                            height="20"
                          />
                          <span> Formulários </span>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            showMenu == "active"
              ? "header__mega-menu active headerClose"
              : "header__mega-menu"
          }
        >
          <div className="topo">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <a
                    href="#"
                    onClick={() => { SetShowMenu(""); setTimeout(() => $("body").css({ overflow: 'visible' }), 260); }}
                    className="btn btn-outline-white btn-icon btn-close rounded transition py-2 px-4"
                  >
                    <img
                      src={Close}
                      alt="Abrir menu"
                      width="14"
                      height="14"
                      className="mr-3"
                    />{" "}
                    <span> Fechar </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="content responsive">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 borda">
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={IcoPredio}
                          alt="prédio"
                          width="22"
                          height="20"
                        />{" "}
                        <span> A Forluz </span>
                      </span>
                    </div>
                    <ul>

                      <li>
                        <a href="/historia"> História </a>
                      </li>
                      <li>
                        <a href="/missao">
                          {" "}
                          Missão, Visão e Valores{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/organograma"> Organograma </a>
                      </li>
                      <li>
                        <a href="/estatuto"> Estatuto </a>
                      </li>
                      <li>
                        <a href="/numeros"> Forluz em Números </a>
                      </li>
                      <li>
                        <a href="/conselhos"> Conselhos </a>
                      </li>
                      <li>
                        {/* <a href="https://www.forluz.org.br/AForluz/SitePages/Comit%C3%AA%20de%20Auditoria.aspx" target="_blank"> Comitê </a> */}
                        <a href="/comite"> Comitê </a>
                      </li>
                      <li>
                        <a href="/diretoria-executiva">
                          {" "}
                          Diretoria Executiva{" "}
                        </a>
                      </li>
                    </ul>

                  </div>
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={IcoDolar}
                          alt="prédio"
                          width="18"
                          height="20"
                        />
                        <span> Acontece na Forluz </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/acontece-na-forluz/noticias"> Notícias </a>
                      </li>
                      <li>
                        <a href="/acontece-na-forluz/comunicados"> Comunicados </a>
                      </li>
                      <li>
                        <a href="/acontece-na-forluz/apresentacoes-especiais">
                          {" "}
                          Apresentações Especiais{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/acontece-na-forluz/publicacoes"> Publicações </a>
                      </li>
                      <li>
                        <a href="/acontece-na-forluz/guia-participante">
                          {" "}
                          Guia do Participante{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/acontece-na-forluz/relatorio-anual-informacoes">
                          {" "}
                          Relatório Anual de Informações{" "}
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* <div className="box-menu">
                    <div className="title">
                      <a
                        href="https://www.forluz.org.br/ParaViverMelhor/Default.aspx"
                        className="d-flex align-items-center"
                      >
                        <img
                          src={IcoViver}
                          alt="prédio"
                          width="23"
                          height="19"
                        />
                        <span> Para Viver Melhor </span>
                      </a>
                    </div>
                  </div> */}
                  <div className="box-menu">
                    <div className="title">
                      <a
                        href="/ViverMelhor/para-viver-melhor"
                        className="d-flex align-items-center"
                      >
                        <img
                          src={IcoViver}
                          alt="prédio"
                          width="23"
                          height="19"
                        />
                        <span> Para Viver Melhor </span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 borda">
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img src={IcoA} alt="prédio" width="20" height="20" />
                        <span> Plano A </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/PlanoA/plano-a"> Descrição </a>
                      </li>
                      <li>
                        <a href="/PlanoA/plano-a-regulamento">
                          {" "}
                          Regulamento{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/PlanoA/plano-a-rentabilidades">
                          {" "}
                          Rentabilidade{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/PlanoA/Demonstracao-Atuarial">
                          {" "}
                          Demonstração Atuarial {" "}
                        </a>
                      </li>
                      <li>
                        <a href="https://hotsiteplanoa.forluz.org.br" target="_blank" rel="noreferrer">
                          {" "}
                          Hotsite do Plano A{" "}
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img src={IcoB} alt="prédio" width="20" height="20" />
                        <span> Plano B </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/PlanoB/plano-b-descricao"> Descrição </a>
                      </li>
                      <li>
                        <a href="/PlanoB/plano-b-regulamento">
                          {" "}
                          Regulamento{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/PlanoB/plano-b-cartilha"> Cartilha do Participante </a>
                      </li>
                      <li>
                        <a href="/PlanoB/plano-b-rentabilidades">
                          {" "}
                          Rentabilidade{" "}
                        </a>
                      </li>
                      {/* <li>
                        <a href="/PlanoB/perfil-de-investimento">
                          {" "}
                          Perfil de Investimento{" "}
                        </a>
                      </li> */}
                      <li>
                        <a href="/PlanoB/Demonstracao-Atuarial">
                          {" "}
                          Demonstração Atuarial {" "}
                        </a>
                      </li>
                      {/*  <li>
                        <a href="https://www.forluz.org.br/SitePages/calculadoraAporte.aspx" target="_blank">
                          {" "}
                          Calculadora de Aporte {" "}
                        </a>
                      </li> */}
                    </ul>
                  </div>

                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img src={IcoT} alt="prédio" width="20" height="20" />
                        <span> Plano TaesaPrev </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/PlanoTaesaprev/plano-taesaprev-descricao">
                          {" "}
                          Descrição{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/PlanoTaesaprev/plano-taesaprev-regulamento">
                          {" "}
                          Regulamento{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/PlanoTaesaprev/plano-taesaprev-cartilha">
                          {" "}
                          Cartilha do Participante{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/PlanoTaesaprev/plano-taesaprev-rentabilidades">
                          {" "}
                          Rentabilidade{" "}
                        </a>
                      </li>
                      {/* <li>
                        <a href="/PlanoTaesaprev/perfil-de-investimento">
                          {" "}
                          Perfil de Investimento{" "}
                        </a>
                      </li> */}
                      <li>
                        <a href="/PlanoTaesaprev/Demonstracao-Atuarial">
                          {" "}
                          Demonstração Atuarial {" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-3 borda">
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={IcoInvestiment}
                          alt="prédio"
                          width="22"
                          height="20"
                        />
                        <span> Investimentos </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/Investimentos/politica-investimentos">
                          {" "}
                          Política de Investimentos{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Investimentos/demonstracoes-financeiras">
                          {" "}
                          Demonstrações Financeiras{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Investimentos/demonstrativos-contabeis">
                          {" "}
                          Demonstrativos Contábeis{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Investimentos/demonstrativos-de-investimentos">
                          {" "}
                          Demonstrativos de Investimentos{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Investimentos/perfil-de-investimento">
                          {" "}
                          Perfil de Investimento{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Investimentos/calculadora-de-aporte">
                          {" "}
                          Calculadora de Aporte{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Investimentos/calculadora-de-contribuicao">
                          {" "}
                          Calculadora de Contribuição{" "}
                        </a>
                      </li>
                    </ul>
                  </div>


                  <div className="box-menu">
                    <div className="title">
                      <a
                        href="/emprestimos"
                        className="d-flex align-items-center"
                      >
                        <img src={IcoMao} alt="prédio" width="23" height="19" />
                        <span> Empréstimos </span>
                      </a>
                    </div>
                  </div>
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={IcoPasta}
                          alt="prédio"
                          width="21"
                          height="18"
                        />
                        <span> Transparência </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/Transparencia/extrato-tac"> Extrato TAC </a>
                      </li>
                      <li>
                        <a href="/Transparencia/acesso-informacao">
                          {" "}
                          Acesso à Informação{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Transparencia/relatorio-circunstanciado"> Relatório Circunstanciado </a>
                      </li>
                      <li>
                        <a href="/Transparencia/relatorio-proposito-especifico"> Relatório Propósito Específico </a>
                      </li>
                      {/*  <li>
                          <a href="/Transparencia/relatorio-anual-informacoes"> Relatório Anual de Informações </a>
                        </li> */}
                    </ul>
                  </div>
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={IcoLivro}
                          alt="prédio"
                          width="15"
                          height="20"
                        />
                        <span> Governança </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/Governanca/politica-gov-corporativa">
                          {" "}
                          Política de Gov. Corporativa{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Governanca/codigo-etica-estatuto">
                          {" "}
                          Código de Conduta e Ética{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Governanca/canal-de-denuncia">
                          {" "}
                          Canal de Denúncia{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Governanca/lgpd"> LGPD </a>
                      </li>
                    </ul>
                  </div>


                  <div className="box-menu">
                    <div className="title">
                      <a href="/gestaoderisco" className="d-flex align-items-center">
                        <img
                          src={IcoEscudo}
                          alt="prédio"
                          width="16"
                          height="19"
                        />
                        <span> Gestão de Riscos </span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={IcoFone}
                          alt="prédio"
                          width="20"
                          height="17"
                        />
                        <span> Contato </span>
                      </span>
                    </div>
                    <ul>
                      <li>
                        <a href="/Contato/fale-conosco"> Fale Conosco </a>
                      </li>
                      <li>
                        <a href="/Contato/perguntas-frequentes">
                          {" "}
                          Perguntas Frequentes{" "}
                        </a>
                      </li>
                      <li>
                        <a href="/Contato/canais-atendimento">
                          {" "}
                          Canais de Atendimento{" "}
                        </a>
                      </li>

                    </ul>
                  </div>
                  <div className="box-menu">
                    <div className="title">
                      <span className="d-flex align-items-center">
                        <img
                          src={icoPerson}
                          alt="prédio"
                          width="20"
                          height="17"
                          color="white"
                        />
                        <span> Gestão de Pessoas </span>
                      </span>
                    </div>
                    <ul>
                      {/* <li>
                          <a href="/Contato/trabalhe-conosco">
                            {" "}
                            Trabalhe conosco{" "}
                          </a>
                        </li> */}
                      <li>
                        <a href="/Contato/nossas-praticas"> Nossas práticas </a>
                      </li>
                      <li>
                        <a href="/Contato/atracao-e-selecao"> Atração e seleção </a>
                      </li>

                    </ul>
                  </div>

                  <div className="box-menu">
                    <div className="title">
                      <a
                        href="/formularios"
                        className="d-flex align-items-center"
                      >
                        <img
                          src={IcoForm}
                          alt="prédio"
                          width="18"
                          height="20"
                        />
                        <span> Formulários </span>
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </header>


      <div className="box-login bg-light py-7 px-5 px-lg-7 hide" id="login"
        style={{
          position: 'fixed',
          widows: '250px',
          transition: 'all 300ms ease 0s',
          height: '100%',
          top: '0px',
          right: participantArea,
          zIndex: '1049'
        }}
      >
        <div className="w-100">
          <a href="https://participante.forluz.org.br/" className="close-login transition">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.99864 4.82178L10.1236 0.696777L11.302 1.87511L7.17698 6.00011L11.302 10.1251L10.1236 11.3034L5.99864 7.17844L1.87365 11.3034L0.695312 10.1251L4.82031 6.00011L0.695312 1.87511L1.87365 0.696777L5.99864 4.82178Z" fill="#383A35" />
            </svg>
          </a>

          <div className="_form">
            <form action="">
              <h3> Acesse sua área restrita </h3>

              <div className="_form__line mt-5">
                <label className="mb-2"> Matrícula </label>
                <input type="text" required />
              </div>

              <div className="_form__line">
                <label className="mb-2"> Senha </label>
                <input type="password" required />
              </div>

              <div className="_form__line">
                <input type="submit" value="Enviar" className="btn disabled transition d-block" />
              </div>

              <div className="text-center">
                <a href="#" className="text-primary"> Esqueceu sua senha? </a>
              </div>

            </form>
          </div>
        </div>
      </div>

    </>
  );
}

export default Header;